import * as ActionTypes from './ActionTypes';
import * as Video2OptInStatusApi from '../api/Video2OptInStatus';
import { reportError } from '../utils/logging';
import { getFailureNotification, getVideo2OptInOutNotification } from '../utils/notifications';
import { Video2OptInStatusTypes } from '../enums/Video2OptInStatusTypes';
import { TRACK_EVENT } from '../Constants';
import { getPortalHasOptedInOrOut } from '../selectors/Video2OptInStatus';
export const fetchVideo2OptInStatus = ({
  showFailureNotification = false
} = {}) => dispatch => {
  dispatch({
    type: ActionTypes.FETCH_VIDEO2_OPT_IN_STATUS_ATTEMPTED
  });
  return Video2OptInStatusApi.fetchVideo2OptInStatus().then(response => {
    const videoOptInStatus = response.get('videoOptInStatus');
    dispatch({
      type: ActionTypes.FETCH_VIDEO2_OPT_IN_STATUS_SUCCEEDED,
      videoOptInStatus,
      meta: {
        [TRACK_EVENT]: {
          eventKey: 'fileManagerVideoOptIn',
          action: 'optin status loaded',
          meta: {
            optInStatus: videoOptInStatus ? videoOptInStatus.get('optInStatus') : 'NOT_OPTED'
          }
        }
      }
    });
  }, err => {
    reportError(err, {
      type: ActionTypes.FETCH_VIDEO2_OPT_IN_STATUS_FAILED
    });
    dispatch({
      type: ActionTypes.FETCH_VIDEO2_OPT_IN_STATUS_FAILED,
      meta: {
        notification: showFailureNotification ? getFailureNotification('videoOptInStatus') : null
      }
    });
  });
};
export const openOptInModal = target => ({
  type: ActionTypes.SET_VIDEO2_OPT_IN_MODAL_OPEN,
  openModal: Video2OptInStatusTypes.OPT_IN,
  meta: {
    [TRACK_EVENT]: {
      eventKey: 'fileManagerVideoOptIn',
      action: 'open optin modal',
      target
    }
  }
});
export const openOptOutModal = target => ({
  type: ActionTypes.SET_VIDEO2_OPT_IN_MODAL_OPEN,
  openModal: Video2OptInStatusTypes.OPT_OUT,
  meta: {
    [TRACK_EVENT]: {
      eventKey: 'fileManagerVideoOptIn',
      action: 'open optout modal',
      target
    }
  }
});
export const closeOptInOptOutModal = () => ({
  type: ActionTypes.SET_VIDEO2_OPT_IN_MODAL_OPEN,
  openModal: null,
  meta: {
    [TRACK_EVENT]: {
      eventKey: 'fileManagerVideoOptIn',
      action: 'close modal'
    }
  }
});
export const turnOnVideo = () => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_ATTEMPTED
  });
  Video2OptInStatusApi.turnOnVideo().then(response => {
    dispatch(closeOptInOptOutModal());
    dispatch({
      type: ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_SUCCEEDED,
      videoOptInStatus: response.get('videoOptInStatus'),
      meta: {
        notification: getVideo2OptInOutNotification('videoOptIn', 'success'),
        [TRACK_EVENT]: {
          eventKey: 'fileManagerVideoOptIn',
          action: 'opted in',
          meta: {
            hasOptedBefore: getPortalHasOptedInOrOut(getState())
          }
        }
      }
    });
  }).catch(err => {
    reportError(err, {
      type: ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_FAILED
    });
    dispatch({
      type: ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_FAILED,
      meta: {
        notification: getVideo2OptInOutNotification('videoOptIn', 'danger'),
        [TRACK_EVENT]: {
          eventKey: 'fileManagerVideoOptIn',
          action: 'optin request failed'
        }
      }
    });
  });
};
export const turnOffVideo = () => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_ATTEMPTED
  });
  Video2OptInStatusApi.turnOffVideo().then(response => {
    dispatch(closeOptInOptOutModal());
    dispatch({
      type: ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_SUCCEEDED,
      videoOptInStatus: response.get('videoOptInStatus'),
      meta: {
        notification: getVideo2OptInOutNotification('videoOptOut', 'success'),
        [TRACK_EVENT]: {
          eventKey: 'fileManagerVideoOptIn',
          action: 'opted out',
          meta: {
            hasOptedBefore: getPortalHasOptedInOrOut(getState())
          }
        }
      }
    });
  }).catch(err => {
    reportError(err, {
      type: ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_FAILED
    });
    dispatch({
      type: ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_FAILED,
      meta: {
        notification: getVideo2OptInOutNotification('videoOptOut', 'danger'),
        [TRACK_EVENT]: {
          eventKey: 'fileManagerVideoOptIn',
          action: 'optout request failed'
        }
      }
    });
  });
};